import React, { useReducer } from "react";
// import axios from "axios";
import axios from "../../axiosinstance";
import UserContext from "./UserContext";
import UserReducer from "./UserReducer";
import {
  REGISTER_SUCCESS,
  GET_USERS,
  UPDATE_USER,
  USER_ACTION_FAIL,
  CLEAR_ERRORS,
} from "../types";

const UserState = (props) => {
  const initialState = {
    new_account: null,
    users: null,
    user: null,
    user_error: null,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const [state, dispatch] = useReducer(UserReducer, initialState);

  // Register User
  const register = async (formData) => {
    try {
      const res = await axios.post("/api/users", formData, config);

      dispatch({
        type: REGISTER_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: USER_ACTION_FAIL,
        payload: err.response.data.msg,
      });
    }
  };

  // Get Users
  const getUsers = async (user_group) => {
    try {
      let res;

      if (user_group) {
        res = await axios.get(`/api/users/${JSON.stringify(user_group)}`);
      } else {
        res = await axios.get("/api/users");
      }

      dispatch({
        type: GET_USERS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: USER_ACTION_FAIL,
        payload: err.response.data.msg,
      });
    }
  };

  // Update User
  const updateUser = async (formData) => {
    try {
      const res = await axios.put("/api/users", formData, config);

      dispatch({
        type: UPDATE_USER,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: USER_ACTION_FAIL,
        payload: err.response.data.msg,
      });
    }
  };

  // Clear Errors
  const clearErrors = () =>
    dispatch({
      type: CLEAR_ERRORS,
    });

  return (
    <UserContext.Provider
      value={{
        new_account: state.new_account,
        users: state.users,
        user: state.user,
        user_error: state.user_error,
        register,
        getUsers,
        updateUser,
        clearErrors,
      }}
    >
      {props.children}{" "}
    </UserContext.Provider>
  );
};

export default UserState;
